<template>
  <v-row class="full-height">
    <v-col cols="8">
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-title>
              <div class="d-flex align-center justify-space-between">
                {{ item.name }}

                <v-tooltip v-if="item.Status" location="bottom">
                  <template #activator="{ props }">
                    <v-chip
                      label
                      :color="item.Status.color"
                      v-bind="props"
                      dark
                    >
                      {{ item.Status.name }}
                    </v-chip>
                  </template>
                  <span>{{ item.Status.description }}</span>
                </v-tooltip>
              </div>
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <ListPage :headers="headers" :items="data.items" :view="['table']">
            <template #charts>
              <v-col cols="6">
                <v-card
                  class="mx-auto text-center"
                  max-width="600"
                  height="200"
                >
                  <v-card-text>
                    <v-sheet color="rgba(0, 0, 0, .12)">
                      <v-sparkline
                        :model-value="chartData.left"
                        color="rgba(12, 90, 213, .7)"
                        height="100"
                        padding="24"
                        stroke-linecap="round"
                        smooth
                      >
                        <template v-slot:label="item">
                          ${{ item.value }}
                        </template>
                      </v-sparkline>
                    </v-sheet>
                  </v-card-text>

                  <v-card-text>
                    <div class="text-h4 font-weight-thin">Sales Last 24h</div>
                  </v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions class="justify-center">
                    <v-btn variant="text" block> Go to Report </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="6">
                <v-card
                  class="mx-auto text-center"
                  max-width="600"
                  height="200"
                >
                  <v-card-text>
                    <v-sheet color="rgba(0, 0, 0, .12)">
                      <v-sparkline
                        :model-value="chartData.left"
                        color="rgba(12, 90, 213, .7)"
                        height="100"
                        padding="24"
                        stroke-linecap="round"
                        smooth
                      >
                        <template v-slot:label="item">
                          ${{ item.value }}
                        </template>
                      </v-sparkline>
                    </v-sheet>
                  </v-card-text>

                  <v-card-text>
                    <div class="text-h4 font-weight-thin">Sales Last 24h</div>
                  </v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions class="justify-center">
                    <v-btn variant="text" block> Go to Report </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </template>

            <template #actions>
              <v-btn
                variant="text"
                border
                color="primary"
                @click="() => (newDialog = !newDialog)"
              >
                <template #prepend>
                  <v-icon>mdi-plus</v-icon>
                </template>
                Add
              </v-btn>
            </template>

            <template #row="{ item, headers }">
              <AdPlacementTableItem
                @on-details="onDetails"
                :value="item"
                :headers="headers"
                @on-delete="onDelete"
              />
            </template>
          </ListPage>
        </v-col>
      </v-row>
    </v-col>

    <v-col cols="4" class="full-height">
      <InventoryItemDetailsMainCard
        v-model="item"
      ></InventoryItemDetailsMainCard>
    </v-col>
    <AdPlacementCreationDialog
      v-model="newDialog"
      @create="create"
      ref="adPlacementCreationDialog"
    />
  </v-row>
</template>



<script>
import { InventoryAPIInstance, AdPlacementAPIInstance } from "../../api";
import AdPlacementCreationDialog from "../../components/organisms/adPlacment/AdPlacementCreationDialog.vue";
import AdPlacementTableItem from "../../components/organisms/adPlacment/AdPlacementTableItem.vue";
import InventoryItemDetailsMainCard from "../../components/organisms/inventoryItem/InventoryItemDetailsMainCard.vue";
import ListPage from "../../components/organisms/layout/ListPage.vue";

export default {
  components: {
    InventoryItemDetailsMainCard,
    AdPlacementCreationDialog,
    ListPage,
    AdPlacementTableItem,
  },
  props: {},
  emits: ["next", "onDetails"],
  data() {
    return {
      newDialog: false,

      chartData: {
        left: [423, 446, 675, 510, 590, 610, 760],
        right: [423, 446, 675, 510, 590, 610, 760],
      },

      item: {
        name: null,
        description: null,
        Website: null,
        PSpot: null,
      },
      data: {
        items: [],
        pagination: {
          page: 1,
          pageSize: 10,
        },
      },
      headers: [
        // { title: "ID", key: "id" },
        { title: "Type", key: "Type" },
        { title: "CPM", key: "CPM" },
        { title: "Resolution", key: "resolution" },
        { title: "Status", key: "Status" },
        { title: "Name", key: "name" },
        { title: "Impressions", key: "Impressions" },
        { title: "Idle", key: "Idle" },
        { title: "Created", key: "created_at" },
        { title: "Actions", key: "Actions" },
      ],
    };
  },
  computed: {},
  created() {
    this.getItem();
    this.getList();
  },
  methods: {
    async getList() {
      const { items, pagination } = await AdPlacementAPIInstance.list(
        this.data.pagination,
        {
          inventoryItemId: this.$route.params.id,
        }
      );

      this.data.items = items;
      this.data.pagination = pagination;
    },
    async getItem() {
      const item = await InventoryAPIInstance.get(this.$route.params.id);
      this.item = item;
    },
    async create(adPlacement) {
      const newPlacement = await AdPlacementAPIInstance.create(
        {
          ...adPlacement,
          inventory_item_id: this.item.id,
        },
        {
          toast: {
            message: "Ad Placement Created",
            color: "success",
          },
        }
      );

      this.$refs.adPlacementCreationDialog.setPlacement(newPlacement);
    },
    async onDelete(id) {
      await AdPlacementAPIInstance.delete(id, {
        toast: {
          message: "Ad Placement Deactivated",
          color: "success",
        },
      });

      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.full-height {
  color: rgb(12, 90, 213);
}
</style>